<template>
  <BuilderWrapper
    title="Zoom"
    helpful-tip="Control how far in and out users can zoom"
  >
    <LabelledInput
      label="Min Zoom"
      helpful-tip="How far out a user can zoom"
    >
      <b-input-group>
        <b-input
          v-model="minZoom"
          type="number"
          min="0"
          max="18"
          step="1"
          :state="zoomValid"
          style="max-width: 6em;"
        />
        <b-input
          v-model="minZoom"
          type="range"
          min="0"
          max="18"
          step="1"
          :state="zoomValid"
        />
      </b-input-group>
    </LabelledInput>

    <LabelledInput
      label="Max Zoom"
      helpful-tip="How far in a user can zoom"
    >
      <b-input-group>
        <b-input
          v-model="maxZoom"
          type="number"
          min="0"
          max="18"
          step="1"
          :state="zoomValid"
          style="max-width: 6em;"
        />
        <b-input
          v-model="maxZoom"
          type="range"
          min="0"
          max="18"
          step="1"
          :state="zoomValid"
        />
      </b-input-group>
    </LabelledInput>

    <LabelledInput
      label="Current Zoom"
      helpful-tip="The current map zoom"
    >
      <b-input-group>
        <b-input
          v-model="mapZoom"
          disabled
        />
        <b-input-group-append>
          <b-button
            id="zoomToMin"
            variant="outline-secondary"
            @click="mapZoom = minZoom"
          >
            Zoom to Min
          </b-button>
          <b-button
            id="zoomToMax"
            variant="outline-secondary"
            @click="mapZoom = maxZoom"
          >
            Zoom to Max
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </LabelledInput>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { MAP_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
}

@Component({ components })
export default class SelectZoom extends Vue {
  get maxZoom () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].maxScale
  }

  set maxZoom (value: number) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'maxScale'],
      value,
    })
  }

  get minZoom () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].minScale
  }

  set minZoom (value: number) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'minScale'],
      value,
    })
  }

  get mapZoom () {
    return this.$typedStore.public.display.mapZoom
  }

  set mapZoom (value: number) {
    this.$typedStore.public.display.setMapZoom(value)
  }

  get zoomValid () {
    return Number(this.minZoom) <= Number(this.maxZoom) ? null : false
  }
}

</script>
